import EditCustomerContainer from './EditCustomerContainer';
import ViewCustomerContainer from './ViewCustomerContainer';
import AddCustomerContainer from './AddCustomerContainer';
import CustomerContainer from './CustomerContainer';
import CreateGroupContainer from './CreateGroupContainer';
import DeleteCustomerContainer from './DeleteCustomerContainer';

export {
	AddCustomerContainer,
	CustomerContainer,
	EditCustomerContainer,
	ViewCustomerContainer,
	CreateGroupContainer,
	DeleteCustomerContainer
};
